import { useLanguage } from "../../contexts/LanguageContext";
import harc from "../pictures/harc_74.jpg"
import harcKH from "../pictures/harcKH.jpg"
function ZHP() {
  const { t } = useLanguage();
  return (
    <section id="zhp" className="animate-fade-in py-10 min-h-full">
      <h1 className="text-5xl font-bold text-center mb-16 bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-cyan-500 leading-tight p-1">
        {t('zhpTitle')}
      </h1>
      
      {/* Działalność w drużynie */}
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center mb-20">
        <div className="order-2 md:order-1">
          <h2 className="text-3xl font-bold text-white mb-4" dangerouslySetInnerHTML={{ __html: t('zhpSubtitle1') }}></h2>
          <p className="text-gray-400 leading-loose">
            {t('zhpText1')}
          </p>
        </div>
        <div className="order-1 md:order-2 group">
           <img 
              src={harc} 
              alt="Damian at the campfire" 
              className="rounded-lg shadow-lg w-full h-auto object-cover transition-all duration-300 transform group-hover:scale-105 group-hover:shadow-cyan-500/20"
            />
        </div>
      </div>

      {/* Działalność w komisji historycznej */}
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
         <div className="group">
           <img 
              src={harcKH} 
              alt="Damian at the commission meeting" 
              className="rounded-lg shadow-lg w-full h-auto object-cover transition-all duration-300 transform group-hover:scale-105 group-hover:shadow-purple-500/20"
            />
            <br />
            <p className="text-gray-700 text-xs"><a target="blank" href="https://www.facebook.com/marand.w">fot. Mariusz „Marand” Wiśniewski </a></p>
        </div>
        <div>
          <h2 className="text-3xl font-bold text-white mb-4" dangerouslySetInnerHTML={{ __html: t('zhpSubtitle2') }}></h2>
          <p className="text-gray-400 leading-loose">
            {t('zhpText2')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ZHP;